module.exports = __webpack_public_path__ + "img/KEYlearning-Welcome2.2283899c.jpg";